import { TosLCRHeader, TosLensPlusHeader } from "./messages.generated";

export const SCROLL_COMPLETION_THRESHOLD = 0.9;

export enum TosSource {
    CreatorPayout = "creator-payout",
    ExclusiveLens = "exclusive-lens",
}

export const TOS_HEADER_MAP = {
    LENS_CREATOR_REWARDS_TERMS: <TosLCRHeader />,
    LENS_CREATOR_LENS_PLUS_TERMS: <TosLensPlusHeader />,
} as const;

export const TOS_KEY_MAP = {
    [TosSource.CreatorPayout]: "LENS_CREATOR_REWARDS_TERMS",
    [TosSource.ExclusiveLens]: "LENS_CREATOR_LENS_PLUS_TERMS",
} as const;
